import { useEffect, useState } from 'react';
import * as diff from 'nike-ui/src/common/push/diff';
import { fromJS, Map } from 'immutable';
import { PickJson } from '../types';
import { subscribePath, unsubscribePath } from '../../turboLive/push/pushSubscriptions';
import { PUSH_PATHS } from '../../turboLive/push/paths';
import { Delta, PushEvent, PushPayload } from '../../turboLive/dto/PushEnvelope';
import { Bet, BetState } from '../../turboLive/dto';
import { BetSnapshot } from '../../turboLive/dto/SnapshotEnvelope';

export function useLivePick(pick: PickJson): { enabled: boolean; odds: number } {
    const isLive = pick.isLive;
    const betId = pick.betId;

    const [bet, setBet] = useState(null);
    const [loaded, setLoaded] = useState(false);
    const betSelection = bet?.get('selections').find(selection => selection.get('code') + '' === pick.selectionCode);
    const odds = betSelection?.get('odds');
    const selectionEnabled = bet?.get('state') === BetState.Running && betSelection?.get('enabled');

    useEffect(() => {
        if (!isLive || !betId) {
            return () => {};
        }
        const path = PUSH_PATHS.betInfo(betId);
        subscribePath(
            path,
            {
                onSnapshot: (snapshot: BetSnapshot) => {
                    setLoaded(true);
                    setBet(fromJS(snapshot.bet));
                },
                onMessage: data => setBet(b => updateBet(data, b))
            },
            true
        );
        return () => {
            unsubscribePath(path);
        };
    }, [betId, isLive]);

    return { enabled: selectionEnabled || !loaded || !isLive, odds };
}

export const updateBet = (push: PushPayload, existing: Map<string, any>) => {
    const data: Bet | Delta | { id: string } = push.d;

    switch (push.e) {
        case PushEvent.CREATED:
            return fromJS(data);
        case PushEvent.UPDATED:
            return diff.applyDelta((data as Delta).diff, existing);
        case PushEvent.DELETED:
            return null;
        default:
            console.error(`Invalid PushEvent ${push}`);
            return null;
    }
};
